import { render, staticRenderFns } from "./GroundTruth.vue?vue&type=template&id=8871d11c&scoped=true"
import script from "./GroundTruth.vue?vue&type=script&lang=js"
export * from "./GroundTruth.vue?vue&type=script&lang=js"
import style0 from "./GroundTruth.vue?vue&type=style&index=0&id=8871d11c&prod&lang=css"
import style1 from "./GroundTruth.vue?vue&type=style&index=1&id=8871d11c&prod&scoped=true&lang=css"
import style2 from "./GroundTruth.vue?vue&type=style&index=2&id=8871d11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8871d11c",
  null
  
)

export default component.exports